import { Component, input } from "@angular/core";
import { VdsStatusDotAppearance, VdsStatusDotSize } from "./types";

@Component({
    selector: "vds-status-dot",
    templateUrl: "./status-dot.html",
    styleUrl: "./status-dot.css",
    host: {
        "[attr.data-size]": "size()",
        "[attr.data-appearance]": "appearance()"
    }
})
export class VdsStatusDot {
    /** The size of the status dot */
    readonly size = input<VdsStatusDotSize>("m");

    /** The appearance of status dot */
    readonly appearance = input<VdsStatusDotAppearance>("primary");
}
